export const getPaymentPercentage = (total: number, dollarValue: number) => {
  const percentage = (dollarValue / total) * 100

  return parseFloat(percentage.toFixed(2))
}
